import styled from 'styled-components'

const TextField = styled.input`
  padding: 10px;
  font-size: 13px;
  display: block;
`
export default TextField
